<template>
  <el-row class="warp">
    <el-col :span="24" class="warp-breadcrum">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }"><b>首页</b></el-breadcrumb-item>
        <el-breadcrumb-item>考试管理</el-breadcrumb-item>
      </el-breadcrumb>
    </el-col>

    <el-col :span="24" class="warp-main" v-loading="loading" element-loading-text="拼命加载中">
      <!--工具条-->
      <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
        <el-form :inline="true" :model="searchForm">
          <el-form-item>
            <el-select  v-model="searchForm.state" placeholder="请选择状态">
                <el-option v-for='(item,index) in stateSelect' :key="index" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
              <el-date-picker
                v-model="searchForm.date"
                type="daterange"
                range-separator="至"
                start-placeholder="创建开始日期"
                end-placeholder="创建结束日期"
                value-format="yyyy-MM-dd HH:mm:ss"
                >
              </el-date-picker>
          </el-form-item>
          <el-form-item>
              <el-date-picker
                v-model="searchForm.validate"
                type="daterange"
                range-separator="至"
                start-placeholder="有效期开始日期"
                end-placeholder="有效期结束日期"
                value-format="yyyy-MM-dd HH:mm:ss"
                >
              </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" v-on:click="handleSearch">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="showAddDialog()">新增</el-button>
          </el-form-item>
        </el-form>
      </el-col>

      <!--列表-->
      <el-table :data="tests" highlight-current-row v-loading="loading" border style="width: 100%;">
        <el-table-column type="index" label="序号" width="60" fixed="left" align="center"></el-table-column>
        <el-table-column prop="title" label="名称" align="center" width="800" ></el-table-column>
        <el-table-column prop="totalScore" label="总分" width="100"  align="center" ></el-table-column>
        <el-table-column prop="lockTimes" label="考试次数" width="120" align="center"></el-table-column>
        <el-table-column prop="examTime" label="考试时长" width="120" align="center"></el-table-column>
        <el-table-column prop="passExam" label="合格分数" width="120" align="center"></el-table-column>
        <el-table-column prop="examRate" label="考试频率" width="150" :formatter="formatter.examRateFormtter" align="center"></el-table-column>
        <el-table-column prop="state" label="启用状态" :formatter="formatter.formatState" width="100" align="center"></el-table-column>
        <el-table-column prop="startDate" label="有效开始时间" width="220" align="center"></el-table-column>
        <el-table-column prop="endDate" label="有效结束时间" width="220" align="center"></el-table-column>
        <el-table-column prop="createDate" label="创建时间" width="180"  align="center"></el-table-column>
        <el-table-column prop="updateDate" label="更新时间" width="180"  align="center"></el-table-column>
        <el-table-column label="操作" fixed="right"  align="center"  width="220" >
          <template slot-scope="scope">
            <el-button type="success" size="mini" @click="showDetailDialog(scope.$index,scope.row)">详情</el-button>
            <el-button type="primary" size="mini" @click="showEditDialog(scope.$index,scope.row)">编辑</el-button>
            <el-button type="danger" size="mini" @click="delTest(scope.$index,scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!--分页工具条-->
      <el-col :span="24" class="toolbar">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-sizes="[10, 20, 50, 100]"
          :page-size="10" background layout="total, sizes, prev, pager, next, jumper" :total="total" style="float:right;">
        </el-pagination>
      </el-col>

      <!--维护界面 -->
      <el-dialog :title="addEditDetialTitle" :visible.sync="addFormVisible" :close-on-click-modal="false">
        <el-form :model="addForm" label-width="80px" ref="addForm">
            <el-form-item label="名称">
                <el-input type="textarea" v-model="addForm.data.title" placeholder="名称"></el-input>
            </el-form-item>
            <el-row>
                <el-col :span="8">
                     <el-form-item label="总分"  :span="12">
                        <template>
                            <el-input-number v-model="addForm.data.totalScore" controls-position="right"  :min="1" :max="100"></el-input-number>
                        </template>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="考试次数" :span="12">
                        <template>
                            <el-input-number v-model="addForm.data.lockTimes" controls-position="right"  :min="1" :max="10"></el-input-number>
                        </template>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="考试时长(分钟)"  label-width="120px;" :span="12">
                        <template>
                            <el-input-number v-model="addForm.data.examTime" controls-position="right"  :min="1" :max="100"></el-input-number>
                        </template>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="8">
                    <el-form-item label="通过分数"  :span="12">
                        <template>
                            <el-input-number v-model="addForm.data.passExam" controls-position="right"  :min="1" :max="100"></el-input-number>
                        </template>
                    </el-form-item>
                </el-col>
                <el-col :span="16">
                    <el-form-item label="有效期" class="clear-margin-bottom">
                        <el-date-picker 
                            v-model="addForm.data.startDate"
                            type="date"
                            :picker-options="pickerOptions" 
                            placeholder="有效开始日期 "
                            value-format="yyyy-MM-dd HH:mm:ss"
                            @change="addForm.dateChange"
                            :disabled="editVisible"
                        ></el-date-picker>
                         -
                         <el-date-picker 
                            v-model="addForm.data.endDate"
                            type="date"
                            :picker-options="pickerOptions" 
                            placeholder="有效结束日期"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            @change="addForm.dateChange"
                        ></el-date-picker>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-form-item label="考试频率"  class="clear-margin-bottom"> 
                <el-radio-group v-model="addForm.data.examRate">
                    <el-radio :label="0"  :disabled="editVisible" >只有一次</el-radio>
                    <el-radio :label="1"  :disabled="editVisible">每周一次</el-radio>
                    <el-radio :label="2"  :disabled="editVisible">每月一次</el-radio>
                    <el-radio :label="3"  :disabled="editVisible">每季一次</el-radio>
                    <el-radio :label="4"  :disabled="editVisible">半年一次</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="启用状态"  class="clear-margin-bottom"> 
                <el-radio-group v-model="addForm.data.state">
                    <el-radio :label="0" >禁用</el-radio>
                    <el-radio :label="1" >启用</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="试题配置" class="clear-margin-bottom">
                <el-row>
                <el-button type="success" icon="el-icon-plus" size="mini" circle @click="addForm.add"  :style="detialEditButton"></el-button>
                </el-row>
                <el-table
                    :data="addForm.data.configList" 
                    style="width: 100%">
                    <el-table-column
                        prop="questionType"
                        label="题目类型"
                        :formatter="formatter.formatType"
                       >
                    </el-table-column>
                    <el-table-column
                        prop="testNum"
                        label="数量">
                    </el-table-column>
                    <el-table-column
                        prop="testScore"
                        label="分/题">
                    </el-table-column>
                    <el-table-column label="操作" fixed="right"  align="center"  width="150" >
                        <template slot-scope="scope">
                        <el-button type="primary" size="mini" @click="addForm.edit(scope.$index,scope.row)"  :style="detialEditButton">编辑</el-button>
                        <el-button type="danger" size="mini" @click="addForm.delete(scope.$index,scope.row)"  :style="detialEditButton">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-form-item>
          
        </el-form>
        <div slot="footer" class="dialog-footer"  :style="detialEditButton">
          <el-button @click.native="addFormVisible = false">取消</el-button>
          <el-button type="primary" @click.native="addForm.addSubmit" >提交</el-button>
        </div>
      </el-dialog>
      <!-- 添加界面 答题配置 -->
      <el-dialog title="试题配置" :visible.sync="configFormVisible" :close-on-click-modal="false">
        <el-form :model="configForm" label-width="80px" ref="configForm">
          <el-form-item label="题目类型" class="clear-margin-bottom">
            <el-select  v-model="configForm.questionType" placeholder="题目类型">
                <el-option v-for='(item,index) in typeSelect' :key="index" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="数量">
            <el-input-number v-model="configForm.testNum" controls-position="right"  :min="0" :max="100"></el-input-number>
          </el-form-item>
          <el-form-item label="分/题">
            <el-input-number v-model="configForm.testScore" controls-position="right"  :min="0" :max="100"></el-input-number>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="configFormVisible = false">取消</el-button>
          <el-button type="primary" @click.native="configForm.submit" >提交</el-button>
        </div>
      </el-dialog>
    </el-col>
  </el-row>
</template>

<script>
import util from '../../common/util'
import API from '../../api/exam/api_test';
export default {
    data(){
        return{
            formatter:{
                 formatType: function (row, column) {
                    var text = '';
                    switch (row.questionType){
                    case 1 : text="单选题";break;
                    case 2 : text="判断题";break;
                    case 3 : text="多选题";break;
                    }
                    return text;
                },
                formatState: function (row, column) {
                    var text = '';
                    switch (row.state){
                        case 0 : text="禁用";break;
                        case 1 : text="启用";break;
                    }
                    return text;
                },
                examRateFormtter:function(row,column){
                    var text = '';
                    switch (row.examRate){
                        case 0 : text="只有一次";break;
                        case 1 : text="每周一次";break;
                        case 2 : text="每月一次";break;
                        case 3 : text="每季一次";break;
                        case 4 : text="半年一次";break;
                    }
                    return text;
                },
            },
            tests:[],
            loading:false,
            total: 0,
            page: 1,
            limit: 10,
            addFormVisible:false,
            configFormVisible:false,
            addEditDetialTitle:'',
            detialEditButton:'inline-block',
            editVisible:false,
            //查询条件
            searchForm:{
                state:"",
                date:"",
                validate:""
            },
            typeSelect:[
                {
                    label:"单选题",
                    value:1
                },
                {
                    label:"判断题",
                    value:2
                },
                {
                    label:"多选题",
                    value:3
                }
            ],
            stateSelect:[
                {
                    label:"启用",
                    value:"1"
                },
                {
                    label:"禁用",
                    value:"0"
                }
            ],
            addForm:{
                data:{
                    title:'',
                    totalScore:'',
                    lockTimes:'',
                    examTime:'',
                    passExam:'',
                    state:'',
                    startDate:'',
                    endDate:'',
                    configList:[]
                },
                //添加配置
                add:function(){},
                edit:function(){},
                delete:function(){},
                //提交
                addSubmit:function(){},
                dateChange:function(){}
            },
            configForm:{
                questionType:'',
                testNum:'',
                testScore:''
            },
            pickerOptions:{
                disabledDate(time) {
                    return time.getTime()<=(Date.now()-1*24*3600*1000); 
                } 

            },
        }       
    },
    methods:{
        initAddFormData:function(){
            this.addForm.data={
                title:'',
                totalScore:'',
                lockTimes:'',
                examTime:'',
                passExam:'',
                state:'',
                startDate:'',
                endDate:'',
                examRate:'',
                configList:[]
            }
        },
        //分页切换每页条数
        handleSizeChange:function(val){
            this.limit = val;
            this.search();
        },
        //分页切换页码
        handleCurrentChange:function(val){
            this.page = val;
            this.search();
        },
        //查询函数
        search:function(){
            let that = this;
            let startDate='';
            let endDate='';
            let validateStart='';
            let validateEnd='';
            if(that.searchForm.date && that.searchForm.date.length>0){
                startDate = that.searchForm.date[0];
                endDate=that.searchForm.date[1];
            }
            if(that.searchForm.validate && that.searchForm.validate.length>0){
                validateStart = that.searchForm.validate[0];
                validateEnd=that.searchForm.validate[1];
            }
            let params = {
                page: this.page,
                limit: this.limit,
                state:this.searchForm.state,
                startDate:startDate,
                endDate:endDate,
                validateStart:validateStart,
                validateEnd :validateEnd,

            };
            //加载
            API.getList(params)
                .then(
                    function (result) {
                    that.loading = false;
                    if (result && result.code == 200) {
                        if(result.data  && result.data.records)
                        {
                            that.total= result.data.total;
                            that.tests=result.data.records;
                        }
                    }
                    },
                    function (err) {
                    that.loading = false;
                    that.$message.error({
                        showClose: true,
                        message: err.toString(),
                        duration: 2000
                    });
                    }
                )
                .catch(function (error) {
                    that.loading = false;
                    console.log(error);
                    that.$message.error({
                    showClose: true,
                    message: "请求出现异常",
                    duration: 2000
                    });
                });
        },
        
        //查询
        handleSearch:function(){
            this.page=1;
            this.total=0;
            this.search();
        },
        //添加
        showAddDialog:function(){
            let that = this;
            that.addEditDetialTitle='新增';
            that.detialEditButton='display:inline-block',
            that.addFormVisible=true;
            that.editVisible=false;
            that.addForm={
                data:{
                    title:'',
                    totalScore:'',
                    lockTimes:'',
                    examTime:'',
                    passExam:'',
                    state:'',
                    startDate:'',
                    endDate:'',
                    examRate:'',
                    configList:[]
                },
                //有效考试时间选择后
                dateChange:function(){
                    if(that.addForm.data.endDate && that.addForm.data.startDate>that.addForm.data.endDate)
                    {
                        that.$message.error("开始时间必须小于等于结束时间");
                        console.log(that.addForm.data);
                        that.addForm.data.endDate='';
                    }
                },
                //添加配置
                add:function(){
                    //判断总分
                    let tempTotalScore=0;
                    that.addForm.data.configList.forEach((a,b)=>{
                        tempTotalScore = tempTotalScore+(a.testNum*a.testScore);
                    })
                    if(tempTotalScore>=that.addForm.data.totalScore){
                        that.$message.error('总分已达到');
                        return;
                    }
                    that.configFormVisible=true;
                    that.configForm={
                        questionType:'',
                        testNum:'',
                        testScore:'',
                        submit:function(){
                            //判断总分
                            let tempTotalScore=0;
                            that.addForm.data.configList.forEach((a,b)=>{
                                tempTotalScore = tempTotalScore+(a.testNum*a.testScore);

                            })
                            tempTotalScore = tempTotalScore+(this.testNum*this.testScore);
                            if(tempTotalScore>that.addForm.data.totalScore){
                                that.$message.error('总分已超过设定的总分');
                                return;
                            }
                            that.addForm.data.configList.push(that.configForm);
                            that.configFormVisible=false;
                        }
                    }
                },
                //编辑按钮
                edit:function(index,row){
                    that.configFormVisible=true;
                    that.configForm={
                        questionType:row.questionType,
                        testNum:row.testNum,
                        testScore:row.testScore,
                        submit:function(){
                             //判断总分
                            let tempTotalScore=0;
                            that.addForm.data.configList.forEach((a,b)=>{
                                //去除要编辑数据
                                if(b!=index){
                                    tempTotalScore = tempTotalScore+(a.testNum*a.testScore);
                                }
                            })
                            tempTotalScore = tempTotalScore+(this.testNum*this.testScore);
                            if(tempTotalScore>that.addForm.data.totalScore){
                                that.$message.error('总分已超过设定的总分');
                                return;
                            }
                            let temp =that.addForm.data.configList[index];
                            temp.questionType=that.configForm.questionType;
                            temp.testNum=that.configForm.testNum;
                            temp.testScore = that.configForm.testScore; 
                            that.configFormVisible=false;
                        }
                    }
                },
                //删除按钮
                delete:function(index,row){
                    that.addForm.data.configList.splice(index,1);
                },
                //提交
                addSubmit:function(){
                    let params =that.addForm.data;
                    console.log(params);
                    that.loading=true;
                    API.add(params)
                        .then(function (result) {
                            that.loading = false;
                                if (result && result.code == 200) {
                                    if(result.data)
                                    {
                                        that.addFormVisible=false;
                                        //成功，重新加载数据
                                        that.total= that.total+1;
                                        let temp =[];
                                        temp.push(result.data);
                                        that.tests=temp.concat(that.tests);
                                    }
                                }else{
                                     that.$message.error({
                                            showClose: true,
                                            message: result.msg,
                                            duration: 2000
                                        });
                                }
                            },
                            function (err) {
                            that.loading = false;
                            that.$message.error({
                                showClose: true,
                                message: err.toString(),
                                duration: 2000
                            });
                            }
                        )
                        .catch(function (error) {
                            that.loading = false;
                            console.log(error);
                            that.$message.error({
                            showClose: true,
                            message: "请求出现异常",
                            duration: 2000
                            });
                        });
                },
            }
        },
        //详情按钮
        showDetailDialog:function(index,row){
            let that = this;
            that.addEditDetialTitle='详情';
            that.detialEditButton='display:none',
            that.addFormVisible=true;
            that.editVisible=false;
            let params ={
                testId:row.id
            }
            that.loading=true;
            API.getDetail(params)
                .then(function (result) {
                    that.loading = false;
                    if (result && result.code == 200) {
                        that.addForm.data=result.data;
                        //console.log(result.data);

                        that.addForm.add=function(){};
                        that.addForm.edit=function(){};
                        that.addForm.delete=function(){};
                    }
                    },
                    function (err) {
                    that.loading = false;
                    that.$message.error({
                        showClose: true,
                        message: err.toString(),
                        duration: 2000
                    });
                    }
                )
                .catch(function (error) {
                    that.loading = false;
                    console.log(error);
                    that.$message.error({
                    showClose: true,
                    message: "请求出现异常",
                    duration: 2000
                    });
                });
        },
        //编辑按钮
        showEditDialog:function(index,row){
            let that = this;
            that.addEditDetialTitle='编辑';
            that.detialEditButton='display:inline-block';
            that.addFormVisible=true;
            that.editVisible=true;
            let params ={
                testId:row.id
            }
            that.loading=true;
            API.getDetail(params)
                .then(function (result) {
                    that.loading = false;
                    if (result && result.code == 200) {
                        that.addForm.data=result.data;
                        that.addForm.dateChange=function(){
                            if(that.addForm.data.endDate && that.addForm.data.startDate>that.addForm.data.endDate)
                            {
                                that.$message.error("开始时间必须小于等于结束时间");
                                console.log(that.addForm.data);
                                that.addForm.data.endDate='';
                            }
                        }, 
                        //绑定按钮
                        //添加配置
                        that.addForm.add=function(){
                            //判断总分
                            let tempTotalScore=0;
                            that.addForm.data.configList.forEach((a,b)=>{
                                tempTotalScore = tempTotalScore+(a.testNum*a.testScore);

                            })
                            if(tempTotalScore>=that.addForm.data.totalScore){
                                that.$message.error('总分已达到');
                                return;
                            }
                            that.configFormVisible=true;
                            that.configForm={
                                questionType:'',
                                testNum:'',
                                testScore:'',
                                submit:function(){
                                    //判断总分
                                    let tempTotalScore=0;
                                    that.addForm.data.configList.forEach((a,b)=>{
                                        tempTotalScore = tempTotalScore+(a.testNum*a.testScore);

                                    })
                                    tempTotalScore = tempTotalScore+(this.testNum*this.testScore);
                                    if(tempTotalScore>that.addForm.data.totalScore){
                                        that.$message.error('总分已超过设定的总分');
                                        return;
                                    }
                                    that.addForm.data.configList.push(that.configForm);
                                    that.configFormVisible=false;
                                }
                            }
                        };
                        //编辑按钮
                        that.addForm.edit=function(index,row){
                            that.configFormVisible=true;
                            that.configForm={
                                questionType:row.questionType,
                                testNum:row.testNum,
                                testScore:row.testScore,
                                submit:function(){
                                    //判断总分
                                    let tempTotalScore=0;
                                    that.addForm.data.configList.forEach((a,b)=>{
                                        //去除要编辑数据
                                        if(b!=index){
                                            tempTotalScore = tempTotalScore+(a.testNum*a.testScore);
                                        }
                                    })
                                    tempTotalScore = tempTotalScore+(this.testNum*this.testScore);
                                    if(tempTotalScore>that.addForm.data.totalScore){
                                        that.$message.error('总分已超过设定的总分');
                                        return;
                                    }
                                    let temp =that.addForm.data.configList[index];
                                    temp.questionType=that.configForm.questionType;
                                    temp.testNum=that.configForm.testNum;
                                    temp.testScore = that.configForm.testScore; 
                                    that.configFormVisible=false;
                                }
                            }
                        };
                        //删除按钮
                        that.addForm.delete=function(index,row){
                            that.addForm.data.configList.splice(index,1);
                        };
                        //提交
                        that.addForm.addSubmit=function(){
                            let params =that.addForm.data;
                            that.loading=true;
                            API.edit(params)
                                .then(function (result) {
                                        that.loading = false;
                                        if (result && result.code == 200) {
                                            that.addFormVisible=false;
                                            let temp = that.tests[index];
                                            temp.title=params.title;
                                            temp.totalScore=params.totalScore;
                                            temp.lockTimes=params.lockTimes;
                                            temp.examTime=params.examTime;
                                            temp.passExam = params.passExam;
                                            temp.state=params.state;
                                            temp.startDate=params.startDate;
                                            temp.endDate=params.endDate;
                                            that.$message.success({
                                                showClose: true,
                                                message: "编辑成功",
                                                duration: 2000
                                            });
                                            }else{
                                            that.$message.error({
                                                showClose: true,
                                                message: "编辑失败",
                                                duration: 2000
                                            });
                                        }
                                    },
                                    function (err) {
                                    that.loading = false;
                                    that.$message.error({
                                        showClose: true,
                                        message: err.toString(),
                                        duration: 2000
                                    });
                                    }
                                )
                                .catch(function (error) {
                                    that.loading = false;
                                    console.log(error);
                                    that.$message.error({
                                    showClose: true,
                                    message: "请求出现异常",
                                    duration: 2000
                                    });
                                });
                        };
                    }
                    },
                    function (err) {
                    that.loading = false;
                    that.$message.error({
                        showClose: true,
                        message: err.toString(),
                        duration: 2000
                    });
                    }
                )
                .catch(function (error) {
                    that.loading = false;
                    console.log(error);
                    that.$message.error({
                    showClose: true,
                    message: "请求出现异常",
                    duration: 2000
                    });
                });
        
        },
        //删除按钮
        delTest:function(index,row){
            let that = this;
            this.$confirm('您确定要删除此试卷吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
            }).then(() => {
                that.loading = true;
                API.deleteById(row.id)
                    .then(
                    function (result) {
                        that.loading = false;
                        if (result && result.code == 200) {
                        that.tests.splice(index,1);
                        that.$message.success({
                            showClose: true,
                            message: "删除成功",
                            duration: 2000
                            });
                        }else{
                        that.$message.error({
                            showClose: true,
                            message: "删除失败",
                            duration: 2000
                            });
                        }
                    },
                    function (err) {
                        that.loading = false;
                        that.$message.error({
                        showClose: true,
                        message: err.toString(),
                        duration: 2000
                        });
                    }
                    )
                    .catch(function (error) {
                        that.loading = false;
                        console.log(error);
                        that.$message.error({
                            showClose: true,
                            message: "请求出现异常",
                            duration: 2000
                        });
                    });
            
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });          
            });
        }
    },
    //页面load加载
     mounted() {
      this.handleSearch();
    }
}
</script>


// WEBPACK FOOTER //
// testpaper.vue?6f7c6f46